/**
 * Away камера для броска с дальней линии
 * Back камера для броска с с ближней
 * Close "наезд" камеры на кюкки
 */
export enum CameraConstants {
    BigAway,
    BigClose,
    BigBack,
    MediumAway,
    MediumClose,
    MediumBack,
    SmallAway,
    SmallClose,
    SmallBack,

    // Bot camera
    BigAwayB,
    BigCloseB,
    BigBackB,
    MediumAwayB,
    MediumCloseB,
    MediumBackB,
    SmallAwayB,
    SmallCloseB,
    SmallBackB,
}